// Combat bundle: projectiles, damage, status effects, zones and the item-effect runtime.
// Subsystems talk to FX through a never-throwing wrapper so a broken effect can't
// take down the combat update.

import type { CombatBundle, GameContext } from '../../core/contracts';
import { createDamage } from './damage';
import { createEffects } from './effects';
import { createSafeFx } from './internal';
import { createProjectiles } from './projectiles';
import { createSfx } from './sfx';
import { createStatus } from './status';
import { createZones } from './zones';

export function createCombat(ctx: GameContext): CombatBundle {
  const fx = createSafeFx(ctx);
  const sfx = createSfx(ctx);
  const status = createStatus(ctx, fx, sfx);
  const projectiles = createProjectiles(ctx, fx, sfx);
  const zones = createZones(ctx, fx, sfx, () => projectiles);
  const damage = createDamage(ctx, fx, sfx, status);
  const effects = createEffects(ctx, fx, sfx);
  return { projectiles, damage, status, zones, effects };
}
